module.exports = __webpack_public_path__ + "e125f013e44ab6770872e1a5982b63c4.svg";